import graphql__462db9c096744c8e855e from "./__generated__/UpdatePaymentTermsDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useRelayEnvironment} from "react-relay/hooks";
import type {UpdatePaymentTermsDialogMutation} from "../../__relay_artifacts__/UpdatePaymentTermsDialogMutation.graphql";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useErrorContext} from "../../contexts/ErrorContext";
import {useIntl} from "react-intl";

type UpdatePaymentTermsDialogProps = {
    paymentMethodIdentifier: string
    currentPaymentTerms: string
    handleCloseDialog: () => void
}

const UpdatePaymentTermsDialog: React.FC<UpdatePaymentTermsDialogProps> = ({paymentMethodIdentifier, currentPaymentTerms, handleCloseDialog}) => {
    const intl = useIntl();
    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling<UpdatePaymentTermsDialogMutation>(
            relayEnvironment,
            {
                mutation: graphql__462db9c096744c8e855e,
                variables: {
                    input: input
                },
                onCompleted: (response, errors) => {
                    if (errors && errors.length > 0) {
                        console.error(errors);
                    }
                    handleCloseDialog();
                },
                onError: (error) => {
                    console.error(error);
                    handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToUpdatePaymentTerms'})
            }
        )
    }

    const initialValues = {
        paymentMethodIdentifier: paymentMethodIdentifier,
        paymentTerms: currentPaymentTerms || 'UponReceipt'
    }

    const validationSchema = yup.object().shape({
        paymentTerms: yup.string().required(intl.formatMessage({id: 'validation.field.required'})),
    });

    return (
        <FormDialog handleCloseDialog={handleCloseDialog} handleSubmission={handleSubmission} initialValues={initialValues} validationSchema={validationSchema} headline={intl.formatMessage({id: 'dialog.UpdatePaymentTermsDialog.headline'})} submitLabel={intl.formatMessage({id: 'button.update'})}>
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.UpdatePaymentTermsDialog.paymentTermsLabel'})}</Label>
                    <Field name="paymentTerms" as="select">
                        <option value="UponReceipt">{intl.formatMessage({id: 'dialog.UpdatePaymentTermsDialog.paymentTerms.uponReceipt'})}</option>
                        <option value="Net7">{intl.formatMessage({id: 'dialog.UpdatePaymentTermsDialog.paymentTerms.net7'})}</option>
                        <option value="Net15">{intl.formatMessage({id: 'dialog.UpdatePaymentTermsDialog.paymentTerms.net15'})}</option>
                        <option value="Net30">{intl.formatMessage({id: 'dialog.UpdatePaymentTermsDialog.paymentTerms.net30'})}</option>
                        <option value="Net60">{intl.formatMessage({id: 'dialog.UpdatePaymentTermsDialog.paymentTerms.net60'})}</option>
                    </Field>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default UpdatePaymentTermsDialog;